import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./../Styles/product.css";

import { useSearchParams } from "react-router-dom";
const IMAGE_URL = "https://lifetimedesign.in/controlpanel/Designs/";

export default function Product() {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const code = params.get("code");
  const cid = params.get("cid");
  const subcid = params.get("subcid");
  const icid = params.get("icid");
  const menu = params.get("menu");
  const [productCache, setProductCache] = useState({});
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  {
    /* ADD THIS FUNCTION INSIDE Product COMPONENT */
  }

  const [relatedDesigns, setRelatedDesigns] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [wishlistLoading, setWishlistLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const [subMenuList, setSubMenuList] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [mobileZoom, setMobileZoom] = useState(false);
  const [mobileZoomData, setMobileZoomData] = useState({
    show: false,
    x: 50,
    y: 50,
  });
  const handleMobileZoom = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const touch = e.touches[0];

    const x = ((touch.clientX - rect.left) / rect.width) * 100;
    const y = ((touch.clientY - rect.top) / rect.height) * 100;

    setMobileZoomData({
      show: true,
      x,
      y,
    });
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const code = searchParams.get("code");

    if (code) {
      document.title = `${code}`;
    }
  }, []);
  const getUser = () => {
    try {
      const user = localStorage.getItem("user");
      return user ? JSON.parse(user) : null;
    } catch {
      return null;
    }
  };

  const user = getUser();
  const userId = user?.id;

  const fetchWishlist = async () => {
    if (!userId) return;

    try {
      setWishlistLoading(true);

      const res = await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/Getwishlist?user_id=${userId}`,
      );

      const result = await res.json();
      setWishlist(result.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setWishlistLoading(false);
    }
  };

  const [loadingCart, setLoadingCart] = useState(false);

  const fetchCart = async () => {
    if (!userId) return;

    try {
      const res = await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/Getcartlist?user_id=${userId}`,
      );

      const result = await res.json();

      // console.log("CART DATA:", result.data);

      setCartItems(result.data || []);
    } catch (err) {
      console.log("Cart fetch error:", err);
    }
  };

  const addToCart = async (design) => {
    if (loadingCart) return;

    try {
      setLoadingCart(true);

      const user = JSON.parse(localStorage.getItem("user"));

      if (!user?.id) {
        alert("Please login first");
        return;
      }

      const designId = design.design_id || design.id;

      const existingItem = cartItems.find(
        (item) => Number(item.design_id ?? item.id) === Number(designId),
      );

      // console.log("EXISTING ITEM:", existingItem);

      let url = "";

      if (existingItem) {
        const cartId = existingItem.cart_id;

        // console.log("REMOVE CART ID:", cartId);

        if (!cartId) {
          alert("cart_id missing");
          return;
        }

        url = `https://lifetimedesign.in/LtcJsonAPI.asmx/RemoveCartDesign?cart_id=${cartId}&user_id=${user.id}`;
      } else {
        url = `https://lifetimedesign.in/LtcJsonAPI.asmx/InsertCartlist?user_id=${user.id}&design_id=${designId}`;
      }

      // console.log("API URL:", url);

      const res = await fetch(url, {
        method: "GET",
      });

      const text = await res.text();

      // console.log("API RESPONSE:", text);

      if (!res.ok) {
        throw new Error("Cart operation failed");
      }

      await fetchCart();
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error(err);
      alert("Cart operation failed");
    } finally {
      setLoadingCart(false);
    }
  };

  const isInCart = (design) => {
    const id = design.design_id || design.id;

    return cartItems.some(
      (item) => Number(item.design_id ?? item.id) === Number(id),
    );
  };

  useEffect(() => {
    if (userId) {
      fetchCart();
    } else {
      setCartItems([]);
    }
  }, [userId]);
  useEffect(() => {
    if (userId) {
      fetchWishlist();
    } else {
      setWishlist([]);
    }
  }, [userId]);
  const isInWishlist = (id) => {
    return wishlist.some(
      (item) => Number(item.design_id ?? item.id) === Number(id),
    );
  };

  const toggleWishlist = async () => {
    if (!userId) {
      alert("Please login first");
      return;
    }

    try {
      setWishlistLoading(true);

      const designId = product?.id || product?.design_id;

      const exists = isInWishlist(designId);

      let url = "";

      if (exists) {
        const item = wishlist.find(
          (i) => Number(i.design_id ?? i.id) === Number(designId),
        );

        url = `https://lifetimedesign.in/LtcJsonAPI.asmx/RemoveWishlistDesign?cart_id=${item.cart_id}&user_id=${userId}`;
      } else {
        url = `https://lifetimedesign.in/LtcJsonAPI.asmx/InsertWishlist?user_id=${userId}&design_id=${designId}`;
      }

      const res = await fetch(url);
      const text = await res.text();

      if (!res.ok) throw new Error(text);

      await fetchWishlist();
      window.dispatchEvent(new Event("wishlistUpdated"));
    } catch (err) {
      console.log(err);
    } finally {
      setWishlistLoading(false);
    }
  };
  const fetchRelatedDesigns = async () => {
    try {
      const url = `https://lifetimedesign.in/LtcJsonAPI.asmx/GetmdesignRelated?code=${code}`;

      const res = await fetch(url);
      const result = await res.json();

      setRelatedDesigns(result.related || []);
    } catch (error) {
      console.log("Related designs error:", error);
      setRelatedDesigns([]);
    }
  };
  // SAME ZOOM EFFECT STATE AS DESIGN DETAILS PAGE
  const [zoomData, setZoomData] = useState({
    show: false,
    x: 0,
    y: 0,
    xP: 0,
    yP: 0,
  });

  useEffect(() => {
    fetchProduct();
    fetchRelatedDesigns();
  }, [code, icid]);

  const fetchProduct = async () => {
    if (!icid || !code) return;

    // ✅ CHECK CACHE FIRST
    if (productCache[code]) {
      setProduct(productCache[code]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      const url = `https://lifetimedesign.in/LtcJsonAPI.asmx/DesignList?icid=${icid}`;

      const res = await fetch(url);
      const result = await res.json();

      const allDesigns = result.data || [];

      const selectedProduct = allDesigns.find((item) => item.code === code);

      setProduct(selectedProduct || null);

      // ✅ SAVE IN CACHE
      if (selectedProduct) {
        setProductCache((prev) => ({
          ...prev,
          [code]: selectedProduct,
        }));
      }
    } catch (error) {
      console.log(error);
      setProduct(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!product?.cid) return;

    fetch(
      `https://lifetimedesign.in/LtcJsonAPI.asmx/SubCategoryList?cid=${product.cid}`,
    )
      .then((res) => res.json())
      .then((result) => {
        setSubMenuList(result.data || []);
      })
      .catch(console.error);
  }, [product?.cid]);
  const subCategoryName = subMenuList.find(
    (s) => s.id.toString() === product?.scid?.toString(),
  )?.subcategorynameweb;

  const breadcrumbItems = [
    {
      label: (
        <>
          <i className="bi bi-house"></i> Home
        </>
      ),
      link: "/",
    },

    subCategoryName && {
      label: subCategoryName,
      link: `/category?cid=${cid}&subcid=${subcid}&icid=${icid}&menu=${encodeURIComponent(menu)}`,
    },

    product?.innercategory && {
      label: product.innercategory,
      link: `/category?cid=${cid}&subcid=${subcid}&icid=${icid}&menu=${encodeURIComponent(menu)}`,
    },

    {
      label: product?.code || "Product",
      link: "#",
    },
  ].filter(Boolean);
  const getImage = () => {
    if (!product?.image_url) return "/images/no-image.png";
    return `${IMAGE_URL}${product.image_url}`;
  };

  // SAME ZOOM FUNCTION AS DESIGN DETAILS PAGE
  const handleMouseMove = (e) => {
    const container = e.currentTarget.getBoundingClientRect();

    const x = e.clientX - container.left;
    const y = e.clientY - container.top;

    const xPercent = (x / container.width) * 100;
    const yPercent = (y / container.height) * 100;

    setZoomData({
      show: true,
      x,
      y,
      xP: xPercent,
      yP: yPercent,
    });
  };
  const handleTouchMove = (e) => {
    const touch = e.touches[0];
    const container = e.currentTarget.getBoundingClientRect();

    const x = touch.clientX - container.left;
    const y = touch.clientY - container.top;

    const xPercent = (x / container.width) * 100;
    const yPercent = (y / container.height) * 100;

    setZoomData({
      show: true,
      x,
      y,
      xP: xPercent,
      yP: yPercent,
    });
  };

  if (loading) {
    return (
      // <div className="container py-5">
      //   <div className="row">
      //     <div className="col-lg-5">
      //       <div className="skeleton-img shimmer"></div>
      //     </div>

      //     <div className="col-lg-5">
      //       <div className="skeleton-text shimmer w-50 mb-3"></div>
      //       <div className="skeleton-text shimmer w-75 mb-2"></div>
      //       <div className="skeleton-text shimmer w-100 mb-2"></div>
      //       <div className="skeleton-text shimmer w-75 mb-4"></div>

      //       <div className="skeleton-btn shimmer"></div>
      //     </div>
      //   </div>
      // </div>
      <div className="page-loader">
        <div className="loader-spinner"></div>
        <h2>Loading Your Design...</h2>
        <p>Please wait while we prepare everything for you.</p>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="text-center mt-5">
        <h4>Product Not Found</h4>
      </div>
    );
  }

  return (
    <div className="container-fluid design-details-container py-4 px-4">
      <div className="w-80">
        {/* BREADCRUMB */}
        <div className="mb-3">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb custom-breadcrumb">
              {breadcrumbItems.map((item, index) => (
                <li
                  key={index}
                  className={`breadcrumb-item ${
                    index === breadcrumbItems.length - 1 ? "active" : ""
                  }`}
                >
                  {index === breadcrumbItems.length - 1 ? (
                    item.label
                  ) : (
                    <a href={item.link}>{item.label}</a>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        </div>

        <div className="row">
          {/* LEFT IMAGE SECTION */}

          <div className="col-lg-6">
            <div
              className="details-image-wrapper mobile-zoom-wrapper shadow-sm rounded"
              onMouseMove={handleMouseMove}
              onMouseLeave={() =>
                setZoomData((prev) => ({
                  ...prev,
                  show: false,
                }))
              }
              onTouchStart={handleMobileZoom}
              onTouchMove={handleMobileZoom}
              onTouchEnd={() =>
                setMobileZoomData((prev) => ({
                  ...prev,
                  show: false,
                }))
              }
            >
              {mobileZoomData.show && (
                <div
                  className="mobile-zoom-box"
                  style={{
                    backgroundImage: `url("${getImage()}")`,
                    backgroundPosition: `${mobileZoomData.x}% ${mobileZoomData.y}%`,
                  }}
                />
              )}
              <img
                src={getImage()}
                alt={product.code}
                className="main-design-img"
              />

              {zoomData.show && (
                <div
                  className="zoom-viewfinder"
                  style={{
                    left: `${zoomData.x - 75}px`,
                    top: `${zoomData.y - 75}px`,
                  }}
                />
              )}
            </div>
          </div>

          {/* RIGHT DETAILS SECTION WITH SAME ZOOM STYLE */}
          <div className="col-lg-6">
            {zoomData.show ? (
              <div
                className="zoom-result-window"
                style={{
                  backgroundImage: `url("${getImage()}")`,
                  backgroundSize: "100%",
                  backgroundPosition: `${zoomData.xP}% ${zoomData.yP}%`,
                }}
              />
            ) : (
              <div className="details-content">
                <span className="badge bg-light mb-2 p-3">Product Details</span>

                {/* <h1 className="h2 fw-bold text-dark mb-3">
                  Design Code: {product.code}
                </h1>

                <h3 className="text-success fw-bold mb-4">₹ {product.price}</h3> */}

                {/* Specifications */}
                <div className="specs-grid p-4 mb-4 bg-light rounded border">
                  <div className="spec-row mb-2">
                    <strong>Code :</strong> {product.code}
                  </div>

                  <div className="spec-row mb-2">
                    <strong>Stitches :</strong> {product.stiches}
                  </div>

                  <div className="spec-row mb-2">
                    <strong>Area :</strong> {product.area}
                  </div>

                  <div className="spec-row mb-2">
                    <strong>Height :</strong> {product.packageno}
                  </div>

                  <div className="spec-row mb-2">
                    <strong>Width :</strong> {product.sequence}
                  </div>

                  <div className="spec-row mb-2">
                    <strong>Colours :</strong> {product.color}
                  </div>
                  <div className="spec-row mb-2">
                    <strong>Concept :</strong> {product.concept}
                  </div>
                  <div className="spec-row mb-2">
                    <strong>Details :</strong> {product.description || "-"}
                  </div>
                  <div className="spec-row">
                    <strong>Price :</strong> ₹ {product.price}
                  </div>
                </div>

                {/* Buttons */}
                <div className="action-buttons d-flex gap-3">
                  <button
                    disabled={loadingCart}
                    className={`btn select-btn flex-fill p-3 ${
                      isInCart(product) ? "in-cart" : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      addToCart(product);
                    }}
                  >
                    {isInCart(product) ? (
                      <>
                        <i className="bi bi-cart-check-fill me-1"></i>
                        SELECTED
                      </>
                    ) : (
                      <>
                        <i className="bi bi-cart me-1"></i>
                        SELECT DESIGN
                      </>
                    )}
                  </button>
                  <button
                    className={`btn btn-wishlist flex-fill p-3 ${
                      isInWishlist(product?.id || product?.design_id)
                        ? "active"
                        : ""
                    }`}
                    onClick={toggleWishlist}
                    disabled={wishlistLoading}
                  >
                    <i
                      className={`bi ${
                        isInWishlist(product?.id || product?.design_id)
                          ? "bi-heart-fill"
                          : "bi-heart"
                      } me-2`}
                    ></i>
                    WISHLIST
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="mt-5">
          <h2 className="section-title">Related Designs</h2>

          {relatedDesigns.length > 0 ? (
            <div className="design-grid1">
              {relatedDesigns.map((item, index) => (
                <div
                  className="design-card"
                  key={`${item.id}-${item.code}-${index}`}
                  onClick={() =>
                    window.open(
                      `/product?code=${item.code}&icid=${item.icid || icid}`,
                      "_blank",
                    )
                  }
                  style={{ cursor: "pointer" }}
                >
                  <div className="uniq-image-wrapper">
                    <img
                      src={`${IMAGE_URL}${item.image_url}`}
                      alt={item.code}
                      className="uniq-design-image"
                      onError={(e) => {
                        e.target.src = "/images/no-image.png";
                      }}
                    />
                  </div>

                  <div className="card-body">
                    <div className="design-specs">
                      <div className="spec-left text-start">
                        <div>
                          <strong>Code:</strong> {item.code}
                        </div>

                        <div>
                          <strong>Stitch:</strong> {item.stiches}
                        </div>

                        <div>
                          <strong>Height:</strong> {item.packageno}
                        </div>

                        <div>
                          <strong>Concept:</strong> {item.concept}
                        </div>
                      </div>

                      <div className="spec-right text-end">
                        <div>
                          <strong>Area:</strong> {item.area}
                        </div>

                        <div>
                          <strong>Color:</strong> {item.color}
                        </div>

                        <div>
                          <strong>Width:</strong> {item.sequence}
                        </div>
                      </div>
                    </div>

                    <h5 className="price-tag-row text-center mt-2">
                      ₹ {item.price}
                    </h5>

                    <div className="card-action-row">
                      <div className="action-btns">
                        <button
                          disabled={loadingCart}
                          className={`select-btn ${
                            isInCart(item) ? "in-cart" : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            addToCart(item);
                          }}
                        >
                          {isInCart(item) ? (
                            <>
                              <i className="bi bi-cart-check-fill me-1"></i>
                              SELECTED
                            </>
                          ) : (
                            <>
                              <i className="bi bi-cart me-1"></i>
                              SELECT DESIGN
                            </>
                          )}
                        </button>

                        <button
                          className={`wish-btn ${
                            isInWishlist(item.id || item.design_id)
                              ? "active"
                              : ""
                          }`}
                          onClick={async (e) => {
                            e.stopPropagation();

                            if (!userId) {
                              alert("Please login first");
                              return;
                            }

                            try {
                              setWishlistLoading(true);

                              const designId = item.id || item.design_id;

                              const exists = isInWishlist(designId);

                              let url = "";

                              if (exists) {
                                const wishItem = wishlist.find(
                                  (i) =>
                                    Number(i.design_id ?? i.id) ===
                                    Number(designId),
                                );

                                url = `https://lifetimedesign.in/LtcJsonAPI.asmx/RemoveWishlistDesign?cart_id=${wishItem.cart_id}&user_id=${userId}`;
                              } else {
                                url = `https://lifetimedesign.in/LtcJsonAPI.asmx/InsertWishlist?user_id=${userId}&design_id=${designId}`;
                              }

                              await fetch(url);
                              await fetchWishlist();

                              window.dispatchEvent(
                                new Event("wishlistUpdated"),
                              );
                            } catch (err) {
                              console.log(err);
                            } finally {
                              setWishlistLoading(false);
                            }
                          }}
                        >
                          <i
                            className={`bi ${
                              isInWishlist(item.id || item.design_id)
                                ? "bi-heart-fill"
                                : "bi-heart"
                            }`}
                          ></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p>No related designs found.</p>
          )}
        </div>
      </div>
    </div>
  );
}
